import { sendRequest, sendRequestReport } from "../axios";

export default {
  state: {
    tariffs: [],
    tariff: {
      id: null,
      title: "",
      valid_period: null,
      count_request: null,
      history_request: false,
      add_users: false,
      download_report: false,
      users_report: false,
      time_support: "",
      personal_manager: false,
      add_improvement: false,
      telegram_chat: false,
      payment_type: "",
      comercial_calc: "+",
      dop_situation_filter: "+",
      dop_customer_filter: "+",
      calc_filter: "+",
      api: false,
      price: null,
    },
    added: true,
    selectedTariff: null,
    selectedPaymentType: "card",
    PaymentCard: {
      card: null,
      mouth: null,
      year: null,
      cvv: null,
    },
    AgentFirmsTariffs: [],
    AgentFirmsTariffFinexpert: [],
  },
  mutations: {
    setAgentFirmsTariffs(state, payload) {
      state.AgentFirmsTariffs = payload;
    },
    setAgentFirmsTariffsFinexpert(state, payload) {
      state.AgentFirmsTariffFinexpert = payload;
    },
    setTariffs(state, payload) {
      state.tariffs = payload;
    },
    setTariff(state, payload) {
      state.tariff = payload;
    },
    setTariffParam(state, payload) {
      state.tariff[payload.name] = payload.value;
    },
    setAdded(state, payload) {
      state.added = payload;
    },
    setselectedTariff(state, payload) {
      state.selectedTariff = payload;
    },
    setSelectedPaymentType(state, payload) {
      state.selectedPaymentType = payload;
    },
    setPaymentCardParam(state, payload) {
      state.PaymentCard[payload.name] = payload.value;
    },
  },
  actions: {
    async GET_AGENT_FRIMS_TARIFFS({ commit }) {
      const { data } = await sendRequest("AllFirmsCounts", "get");
      commit("setAgentFirmsTariffs", data.allFirms);
    },
    async GET_AGENT_FRIMS_TARIFFS_FINEXPERT({ commit }) {
      const { data } = await sendRequest("AllFirmsCountsFinexpert", "get");
      commit("setAgentFirmsTariffsFinexpert", data.allFirms);
    },
    async SET_AGENT_FIRM_TARIFF({ commit }, payload) {
      const { data } = await sendRequest("FirmCount", "post", payload);
      return data;
    },
    async GET_PAYMENTS_TARIFFS({ commit }) {
      const { data } = await sendRequest("tariff", "get");
      commit("setTariffs", data.tariffs);
    },
    async ADD_PAYMENTS_TARIFFS({ commit }, payload) {
      const { data } = await sendRequest("tariff", "post", payload);
      commit("setTariffs", data.tariffs);
      return data.tariff;
    },
    async EDIT_PAYMENTS_TARIFFS({ commit }, payload) {
      const { data } = await sendRequest(
        `tariff/${payload.id}`,
        "put",
        payload
      );
      commit("setTariffs", data.tariffs);
      return data.tariff;
    },
    async DELETE_PAYMENTS_TARIFFS({ commit }, payload) {
      const { data } = await sendRequest(`tariff/${payload.id}`, "delete");
      commit("setTariffs", data.tariffs);
      return data.tariff;
    },
    async GENERATE_A_BILL({ commit }, payload) {
      const { data } = await sendRequestReport(`bill`, "post", payload);
      return data;
    },
  },
  getters: {
    tariffs: (state) => state.tariffs,
    tariff: (state) => state.tariff,
    added: (state) => state.added,
    selectedTariff: (state) => state.selectedTariff,
    selectedPaymentType: (state) => state.selectedPaymentType,
    PaymentCard: (state) => state.PaymentCard,
    AgentFirmsTariffs: (state) => state.AgentFirmsTariffs,
    AgentFirmsTariffFinexpert: (state) => state.AgentFirmsTariffFinexpert,
  },
};
